import { buildAssetUrl } from './api';

export const normalizeProductCard = (product) => {
  const price = Number.parseFloat(product.starting_price ?? product.price ?? 0);
  const originalPrice = Number.parseFloat(product.original_price ?? product.originalPrice ?? price);
  const safePrice = Number.isFinite(price) ? price : 0;
  const safeOriginalPrice = Number.isFinite(originalPrice) ? originalPrice : safePrice;

  return {
    ...product,
    id: product.product_id ?? product.id,
    product_id: product.product_id ?? product.id,
    name: product.name ?? product.product_name ?? 'Product',
    image: buildAssetUrl(
      product.image ??
      product.image_url ??
      product.product_image ??
      product.primary_image ??
      product.image1 ??
      product.gallery_images?.[0] ??
      null
    ),
    category: product.category_name ?? product.category ?? '',
    price: safePrice,
    originalPrice: safeOriginalPrice,
    gst: Number.parseFloat(product.gst ?? product.gst_percentage ?? 0) || 0,
    discount: safeOriginalPrice > safePrice
      ? Math.round(((safeOriginalPrice - safePrice) / safeOriginalPrice) * 100)
      : 0,
    unit: product.variants?.[0]?.unit_name ?? product.variants?.[0]?.unit ?? product.unit_name ?? (product.unit && product.unit !== "unit" ? product.unit : ""),
    unit_name: product.variants?.[0]?.unit_name ?? product.unit_name ?? null,
    // ── Legacy stock booleans ──────────────────────────────────────────────
    inStock: product.inStock ?? product.is_in_stock ?? true,
    is_in_stock: product.is_in_stock ?? product.inStock ?? true,
    // ── Location-aware stock fields (new API) ──────────────────────────────
    // available_stock: net qty after reserved/damaged/expired deduction
    available_stock: product.available_stock ?? product.available_qty ?? null,
    available_qty: product.available_qty ?? product.available_stock ?? null,
    // stock_status token: OUT_OF_STOCK | LOW_STOCK | LIMITED_STOCK | IN_STOCK
    stock_status: product.stock_status ?? null,
    // stock_level: lowercase alias returned by some endpoints (in_stock, low_stock…)
    stock_level: product.stock_level ?? null,
    stock_message: product.stock_message ?? null,
    // is_out_of_stock: boolean flag (true when available_stock === 0)
    is_out_of_stock: product.is_out_of_stock ??
      (product.stock_status === 'OUT_OF_STOCK') ??
      (product.available_stock === 0) ??
      false,
    store_id: product.store_id ?? null,
    // ── Variants with stock fields propagated ─────────────────────────────
    variants: (Array.isArray(product.variants) && product.variants.length > 0)
      ? product.variants.map((v) => ({
          ...v,
          available_stock: v.available_stock ?? null,
          stock_status: v.stock_status ?? product.stock_status ?? null,
          stock_level: v.stock_level ?? product.stock_level ?? null,
          stock_message: v.stock_message ?? product.stock_message ?? null,
          is_out_of_stock: v.is_out_of_stock ?? (v.stock_status === 'OUT_OF_STOCK') ?? false,
          is_in_stock: v.is_in_stock ?? (v.stock_status !== 'OUT_OF_STOCK') ?? true,
        }))
      : (product.product_variant_id != null || product.variant_id != null)
        ? [{
            product_variant_id: product.product_variant_id ?? product.variant_id,
            variant_id: product.variant_id ?? product.product_variant_id,
            variant_name: product.variant_name ?? product.unit_name ?? product.unit ?? '1 unit',
            unit_name: product.unit_name ?? product.unit ?? null,
            price: safePrice,
            discount_price: safePrice,
            original_price: safeOriginalPrice,
            available_stock: product.available_stock ?? null,
            stock_status: product.stock_status ?? null,
            stock_level: product.stock_level ?? null,
            is_out_of_stock: product.is_out_of_stock ?? (product.stock_status === 'OUT_OF_STOCK') ?? false,
            is_in_stock: product.is_in_stock ?? true,
          }]
        : [],
  };
};
